import { IFormattedAnswer, IFormattedAnswers, IQuestion } from './types';
export const formatAnswer = (
    question: IQuestion,
    msrp: number,
    includeFinanceType: boolean,
    includeGovernmentFees: boolean
): IFormattedAnswer => {
    const questionLabel = question?.question || '';
    let defaultFieldValue: any = '';

    const isFalse = ['false', 'False'].indexOf(question.default) > -1 || question.default === false;
    const isTrue = ['true', 'True'].indexOf(question.default) > -1 || question.default === true;
    const isLastName = question?.question.toLowerCase().indexOf('last name') !== -1;
    const isRegistrationCityName = (question.id === 'RegistrationCityName' || question.id === 'NumLiens') && !includeGovernmentFees;

    if (isFalse) {
        defaultFieldValue = false;
    } else if (isTrue) {
        defaultFieldValue = true;
    } else if (question.options.length > 0) {
        defaultFieldValue = formatAnswerByOptions(question);
    } else if (isLastName) {
        defaultFieldValue = 'Horsepower';
    }

    // Check for registration city name and num liens as well
    else if (isRegistrationCityName) {
        defaultFieldValue = 'LET IT RAIN!!!';
    } else {
        defaultFieldValue = formatAnswerById(question, msrp);
    }

    const formattedAnswer: IFormattedAnswer = {
        id: question.id,
        question: questionLabel,
        answer: defaultFieldValue
    };

    if (includeFinanceType) {
        formattedAnswer.financeType = question.financeType;
    }

    return formattedAnswer;
};

export const formatAnswerByOptions = (question: IQuestion): string | number | boolean => {
    let defaultFieldValue;
    if (question.id === 'FeeCalculationType') {
        defaultFieldValue = 1;
    } else if (question.options.find((option: any) => option.id === question.default)) {
        defaultFieldValue = question.default;
    } else if (question.id === 'LocationID') {
        defaultFieldValue = question.default || question.options[0].value;
    } else {
        defaultFieldValue = question.options[0]?.id || question.options[0].value;
    }

    return defaultFieldValue;
};

export const formatAnswerById = (question: IQuestion, msrp: number): string | number | boolean => {
    let defaultFieldValue;
    switch (question.id) {
        case 'District':
            defaultFieldValue = 'Outside City Limits';
            break;
        case 'RegYears':
            defaultFieldValue = question.default || 1;
            break;
        case 'FeeCalculationType':
            defaultFieldValue = 1;
            break;
        case 'GrossSalesPrice':
            defaultFieldValue = msrp || 0;
            break;

        case 'OwnerBirthDate':
            defaultFieldValue = '01/01/1985';
            break;
        default:
            defaultFieldValue = question.default;
            break;
    }

    return defaultFieldValue;
};

export const createDefaultLocationFromAnswers = (
    questions: IQuestion[],
    includeGovermentFees: boolean,
    includeFinanceType: boolean,
    msrp: number
): IFormattedAnswers => {
    return questions.reduce((answers: IFormattedAnswers, question: IQuestion) => {
        answers[question.id] = formatAnswer(question, msrp, includeFinanceType, includeGovermentFees);
        return answers;
        // tslint:disable-next-line:align
    }, {});
};
